<script lang="ts">
import { defineComponent } from "vue";
import KlereoIcon from "@/shared/components/KlereoIcon.vue";

export default defineComponent({
  components: { KlereoIcon },
  emits: ["close"],
  props: {
    opened: {
      type: Boolean,
      required: true,
    },
    withCloseButton: {
      type: Boolean,
      default: false,
    },
  },
});
</script>

<template>
  <div
    class="fixed inset-0 bg-black bg-opacity-75 z-[1000] p-10 flex flex-col justify-items-stretch items-stretch md:items-center"
    @click.self="$emit('close')"
    v-if="opened"
  >
    <div
      class="rounded bg-gray-700 shadow-2xl text-white card border-none md:max-w-md md:min-w-[300px] overflow-hidden flex flex-col"
      style="border: none"
    >
      <div
        v-if="withCloseButton"
        @click="$emit('close')"
        class="flex flex-row-reverse mb-[-15px] cursor-pointer shrink-0"
      >
        <klereo-icon
          name="x"
          class="cursor-pointer w-[40px] bigger-clickable-area"
          @click="$emit('close')"
        />
      </div>

      <div class="p-5 px-10 overflow-auto">
        <slot></slot>
      </div>
    </div>
  </div>
</template>
